import React, { useMemo, useRef } from "react";

import {
  HvDropdownProps,
  HvTag,
  HvTypography,
} from "@hitachivantara/uikit-react-core";

import { Status } from "lib/api";
import BaseDropdown from "../BaseDropdown";

interface StatusDropdownProps extends Omit<HvDropdownProps, "values"> {
  statuses?: Status[];
  defaultValue?: number;
}

const StatusDropdown = ({
  statuses,
  defaultValue,
  disabled,
  ...other
}: StatusDropdownProps): JSX.Element => {
  const initialSelectedRef = useRef(defaultValue);
  const dropdownValues = useMemo(
    () =>
      statuses?.map((r) => ({
        id: r.pk_status_id.toString(),
        label: (
          <HvTag
            label={
              <HvTypography variant="normalText">{r.status_name}</HvTypography>
            }
            type="categorical"
            color={r.status_color}
            style={
              r.status_text_color != null ? { color: r.status_text_color } : {}
            }
            disabled={disabled}
            tabIndex={-1}
          />
        ),
        searchValue: r.status_name,
        selected:
          initialSelectedRef.current != null
            ? initialSelectedRef.current === r.pk_status_id
            : r.status_is_default,
      })),
    [disabled, statuses]
  );

  return (
    <BaseDropdown
      values={dropdownValues}
      singleSelectionToggle={false}
      disabled={disabled}
      {...other}
    />
  );
};

export default StatusDropdown;
